function GetInvolved() {
  const cards = [
    {
      icon: 'fa-hand-holding-heart',
      title: 'Donate',
      desc: 'Your contribution directly provides school supplies to Dallas students and STEM education resources to Nepal students.',
      items: [
        { bold: '$30', text: ' - School supplies for 1 Dallas student' },
        { bold: '$50', text: ' - STEM kit materials for Nepal' },
        { bold: '$100', text: ' - Teacher training in rural Nepal' },
        { bold: '$300', text: " - Sponsor a full school's supply drive" },
      ],
      cta: 'Donate Now',
      href: '#donate',
      btnClass: 'btn btn-primary',
    },
    {
      icon: 'fa-users',
      title: 'Volunteer',
      desc: 'Share your time and skills to support our programs in Dallas and Nepal.',
      items: [
        { bold: 'Supply Drive Coordinator:', text: ' Organize Dallas back-to-school drives' },
        { bold: 'STEM Mentor:', text: ' Virtually mentor Nepal students' },
        { bold: 'Event Support:', text: ' Help with fundraising events' },
        { bold: 'Professional Skills:', text: ' Grant writing, marketing, accounting' },
      ],
      cta: 'Volunteer',
      href: 'mailto:contact@joinbtlf.org',
      btnClass: 'btn btn-outline',
    },
    {
      icon: 'fa-building',
      title: 'Partner',
      desc: 'Schools, businesses, and foundations can partner with us to amplify impact.',
      items: [
        { bold: 'Schools:', text: ' Partner for supply distribution or mentorship' },
        { bold: 'Corporations:', text: ' Employee giving, matching gifts, sponsorships' },
        { bold: 'Foundations:', text: ' Grant support for sustainable programs' },
        { bold: 'Tech Companies:', text: ' Dallas tech community engagement' },
      ],
      cta: 'Become a Partner',
      href: 'mailto:contact@joinbtlf.org',
      btnClass: 'btn btn-outline',
    },
  ];

  return (
    <section className="get-involved" id="get-involved">
      <div className="container">
        <div className="section-header centered">
          <h2 className="section-title">Get Involved</h2>
          <p className="section-subtitle">
            Join us in building bridges to learning for deserving students
          </p>
        </div>
        <div className="involvement-options">
          {cards.map((card, i) => (
            <div className="involvement-card" key={i}>
              <div className="involvement-icon">
                <i className={`fas ${card.icon}`}></i>
              </div>
              <h3>{card.title}</h3>
              <p>{card.desc}</p>
              <ul>
                {card.items.map((item, j) => (
                  <li key={j}><strong>{item.bold}</strong>{item.text}</li>
                ))}
              </ul>
              <a href={card.href} className={card.btnClass}>{card.cta}</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default GetInvolved;
